module.exports = __webpack_public_path__ + "img/Weapon_01.e45fe582.png";